const CAP41 = {
  "id": 190,
  "title": "UTXO",
  "slug": "utxo-bitcoin",
  "type": "lesson",
  "category": "bitcoin-avanzado",
  "level": "advanced",
  "preview": "Las UTXO representan las monedas no gastadas dentro de Bitcoin y permiten comprender cómo se gestiona el saldo, se previene el doble gasto y se estructuran todas las transacciones.",
  "sections": [
    {
      "heading": "¿Qué es una UTXO?",
      "text": [
        "En Bitcoin todas las transacciones tienen una estructura de entradas y salidas.",
        "En las Entradas de una transacción podemos ver los orígenes del saldo manejado por nuestra wallet. En las Salidas vemos hacia dónde enviamos ese dinero, incluyendo el cambio restante.",
        "Todo ello es visible y trazable porque la blockchain de Bitcoin es pública.",
        "Las entradas se denominan HASH ID de una transacción. Las monedas dadas como cambio y que no han sido gastadas aún reciben el nombre de UTXO (Unspent Transaction Output).",
        "Una salida puede generar una o varias UTXO nuevas, y una dirección puede contener infinitas UTXO.",
        "Para enviar una transacción, el monedero debe utilizar UTXO existentes que no hayan sido gastadas previamente.",
        "Una UTXO solo puede usarse una vez. Esta es una de las claves que evita el doble gasto en Bitcoin.",
        "El total de monedas existentes en circulación puede calcularse sumando todas las UTXO no gastadas."
      ]
    },
    {
      "heading": "Ejemplo práctico del funcionamiento de UTXO",
      "text": [
        "Alicia quiere pagar a Bruno un total de 0,1 BTC por un trabajo.",
        "En su wallet, Alicia dispone de dos entradas: 0,09 BTC y 0,06 BTC (total 0,15 BTC).",
        "El monedero utiliza ambas entradas para generar una salida hacia Bruno de 0,1 BTC.",
        "Se genera una UTXO adicional a favor de Alicia por 0,04 BTC como cambio.",
        "Esto sucede porque las UTXO son indivisibles: deben gastarse por completo al usarlas en una transacción, produciendo nuevas UTXO como resultado.",
        "Algunas transacciones no provienen de UTXO previas, como las transacciones coinbase, creadas al minar un bloque."
      ]
    },
    {
      "heading": "Modelo de Entradas y Salidas",
      "text": [
        "Este modelo permite establecer relaciones claras sobre la posesión del dinero gracias al uso de criptografía.",
        "Cada transacción contiene una entrada que representa una UTXO previa, y una salida que representa una nueva UTXO.",
        "Para que un saldo exista dentro de tu wallet, este debe estar representado como una UTXO.",
        "Las monedas recién generadas en un bloque se originan como una transacción coinbase y crean una UTXO inicial para el minero.",
        "Este proceso se repite en toda la red, garantizando trazabilidad y control criptográfico del dinero."
      ]
    },
    {
      "heading": "Bitcoin Script y las UTXO",
      "text": [
        "Cada UTXO se valida mediante Bitcoin Script, el lenguaje de programación de Bitcoin.",
        "Cada transacción tiene un script asociado que permite:",
        "— Validar que el saldo usado pertenece realmente al usuario.",
        "— Garantizar que los fondos enviados solo puedan ser gastados por el destinatario.",
        "Los scripts definen las condiciones de gasto de cada salida de transacción y son clave para la seguridad de Bitcoin."
      ]
    },
    {
      "heading": "Curiosidades de las UTXO",
      "text": [
        "Existen transacciones especiales que no provienen de UTXO previas, como las transacciones coinbase (recompensa del minero).",
        "Las UTXO son indivisibles hasta que se gastan y producen nuevas UTXO.",
        "Si un usuario desea pagar 1 BTC pero tiene 100 UTXO de 0,01 BTC, el monedero tomará las 100 UTXO como entradas.",
        "Todas esas UTXO quedarán marcadas como gastadas y se generará una nueva UTXO con el monto total enviado."
      ]
    },
    {
      "heading": "Relación entre UTXO y comisiones",
      "text": [
        "Las comisiones en Bitcoin se calculan como: Entrada total - Salida total = Comisión.",
        "La comisión no se asigna a ninguna salida, por lo que los mineros la reciben.",
        "Las comisiones sirven para:",
        "1. Incentivar el trabajo de los mineros.",
        "2. Proteger la red frente a ataques como DDoS o dusting attack.",
        "Cada transacción tiene un coste, por lo que realizar miles de transacciones maliciosas resulta caro para el atacante."
      ]
    },
   {
  "heading": "Tabla comparativa: Entradas, Salidas y UTXO",
  "table": {
    "columns": [
      "Concepto",
      "Descripción",
      "Función"
    ],
    "rows": [
      [
        "Entrada",
        "Referencia a una UTXO previa que se está gastando. Contiene el HASH ID de esa transacción.",
        "Indica de dónde vienen los fondos utilizados."
      ],
      [
        "Salida",
        "Dirección de destino que recibirá los fondos y generará nuevas UTXO.",
        "Define a quién se envía el dinero y crea nuevas monedas no gastadas."
      ],
      [
        "UTXO",
        "Unspent Transaction Output: monedas no gastadas disponibles en una dirección.",
        "Es el saldo real del usuario; solo pueden gastarse una vez."
      ]
    ]
  }
}

  ]
}



export default CAP41;
